import comp from "./UserDetails";
export default comp;
